import { InjectionToken } from "@angular/core";

/** Valgfri styring af app-shell (fx servicepro uden Forsyning|Web-undermenu). */
export interface AppShellLayoutOptions {
    /** Skjul Forsyning|Web-højremenu og knappen der åbner den (mobil). */
    hideForsyningWebMenu?: boolean;
    /** Ekstra path-værdier (uden leading slash) der tælles som login-side. Fx `""` når login ligger på `/`. */
    extraLoginRoutePaths?: string[];
    /** Skjul "Forbruger"-gruppen i venstremenuen (fx servicepro, hvor forbruger åbnes andetsteds). */
    hideForbrugerMenu?: boolean;
    /** Skjul "Log ind som forbruger/tekniker"-link på login (ServicePro har kun tekniker-login). */
    hideLoginRoleSwitch?: boolean;
    /** Standard-landing efter login og for allerede logget-ind bruger på login-rute (fx `/min-side` i ServicePro). */
    defaultLandingRoute?: string;
    /** Destination efter valg i install-picker (fx `/opgaver` i ServicePro). Default: `/opgaver`. */
    installPickerRedirectRoute?: string;
    /** Redirect fra min-side når `hentOpgaver` returnerer tom liste (fx `/install-picker` i ServicePro). */
    minSideEmptyRedirectRoute?: string;
    /**
     * Hash-rute til tekniker-login i denne app (fx `/servicepro-login` i ServicePro NUI).
     * Styrer bl.a. logout-redirect og `LoginTechnician.navigateToLoginPage` når sat.
     */
    teknikerLoginRoute?: string;
    /** Basis-sti til statiske assets (fx `/assets` i ServicePro, `/dist/e-forsyning/assets` i e-forsyning). */
    assetsBasePath?: string;
    /**
     * Login-baggrundsbillede (fuld sti under web-root, fx `/assets/images/background/servicepro.jpg`).
     * Default i login-container: `/assets/images/background/strings.jpg` (eForsyning).
     */
    loginBackgroundImage?: string;
    /** Logo/navnetræk på tekniker-login (fx ServicePro PNG i stedet for tekst). */
    loginBrandImage?: string;
    /** Alternativt logo til dark mode (vises når brugeren har valgt mørkt tema). */
    loginBrandImageDark?: string;
    /** Umbraco content-type aliases der skjules i sidemenu (fx ServicePro-only sider). */
    hiddenMenuAliases?: string[];
    /**
     * Ved 401 på den primære appserver-session: forny cryptId stille med gemte session-credentials
     * og gentag requesten én gang, før brugeren sendes til login.
     */
    silentReauthOn401?: boolean;
    /** Absolut maks-levetid (ms) for en session fra interaktivt login; derefter kræves nyt login. Default 12 timer. */
    maxSessionLifetimeMs?: number;
    /** Klientens inaktivitets-timeout (ms) for appserver-session. Default 1 time. */
    sessionTimeoutMs?: number;
}

export const APP_SHELL_LAYOUT_OPTIONS = new InjectionToken<AppShellLayoutOptions>("APP_SHELL_LAYOUT_OPTIONS");
